var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtWalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 27"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FT_walk_svg__a",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h10v17H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FT_walk_svg__b",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-108-245h375V785h-375z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FT_walk_svg__c",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h12v18H-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FT_walk_svg__d",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73 8.36l-2-1.23a.91.91 0 01-.33-.44l-.64-2.24a.52.52 0 00-.07-.15.53.53 0 00-.47-.3l-2.67.12a.51.51 0 00-.31.13h-.06L1.37 5.76a.86.86 0 00-.27.79l.72 3.26a.61.61 0 00.58.47h.32a.47.47 0 00.35-.28.52.52 0 00.09-.42l-.51-2.47a.47.47 0 01.14-.41l.32-.27.17 4-.74 1.73a1.89 1.89 0 01-.51.65L.3 14.17a.86.86 0 00-.24 1l.24.53a.53.53 0 00.49.3.59.59 0 00.35-.12l2.28-1.79a2.89 2.89 0 00.64-.79L5.19 11v-.05h.11l1.86 5.42A.93.93 0 008 17a.86.86 0 00.28 0h.11a.89.89 0 00.52-.47 1 1 0 000-.71L7 10l-.08-1.57 2.16 1.18a.52.52 0 00.73-.23l.12-.25a.59.59 0 00-.2-.77z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "FT_walk_svg__e",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4h.09a2 2 0 001.38-.65A2 2 0 007 1.91 2 2 0 003.53.65 2 2 0 003 2.09 2 2 0 005 4z",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_walk_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_walk_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_walk_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_walk_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_walk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2b3c46",
    d: "M0 4h20v23H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_walk_svg__e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#FT_walk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2b3c46",
    d: "M3 0h14v14H3z"
  }))))))));
}
export default SvgFtWalk;